
define([
    'jquery',
    'velocity'
],  function ($, velocity) {

    function DPAccordion(currentElement, options) {
        this.container = currentElement;
        this.blocks = null;
        this.namespace = 'dpaccordion';

        this._applySettings(this._defaultSettings, options);

        this.activeBlock = null;

        this.init();
    }

    DPAccordion.prototype = {

        _defaultSettings: {
            opener: '.opener',
            blockContainer: 'li',
            classOpened: 'opened',
            contentBlock: '.content-block',
            collapsible: true,
            duration: 300, // ms
            expand: true //expand = true for accordion, false for open-close

        },

        init: function() {
            this._cacheElements();
            this._bindEvents();

            this._setInitState();
        },

        _cacheElements: function() {
            this.blocks = this.container.find(this.blockContainer);
            this.controllers = this.blocks.find(this.opener + ':first');
        },

        _bindEvents: function() {
            this.controllers.on('click.'+ this.namespace, $.proxy(this._onControllerClick, this));
        },

        _unbindEvents: function() {
            this.controllers.off('.' + this.namespace);
        },

        _setInitState: function() {
            var self = this;
            var isOpenMore = true;

            this.blocks.each(function(index, element) {
                var currentBlock = $(element),
                    contentBlock = currentBlock.find(self.contentBlock).first();

                if (currentBlock.hasClass(self.classOpened)) {
                    if (self.expand && !isOpenMore) {
                        contentBlock.height(0);
                        currentBlock.removeClass(self.classOpened);
                        isOpenMore = false;
                    }
                    currentBlock.find(self.opener).find("button").attr('aria-expanded', 'true');
                    currentBlock.find(self.contentBlock).attr('aria-hidden', 'false');
                }else {
                    contentBlock.height(0);
                    currentBlock.find(self.opener).find("button").attr('aria-expanded', 'false');
                    currentBlock.find(self.contentBlock).attr('aria-hidden', 'true');
                }
            });

            this.container.trigger('');
        },

        _onControllerClick: function(event) {
            var targetBlock = $(event.currentTarget).closest(this.blocks);

            event.preventDefault();

            if (targetBlock.hasClass(this.classOpened)) {
                if (this.collapsible) {
                    this._closeBlock(targetBlock);
                }
            }else {
                if (this.expand) {
                    this._closeBlock(this.blocks.filter('.' + this.classOpened));
                }
                this._openBlock(targetBlock);
            }
        },

        _openBlock: function(container) {
            var currentBlock = container.find(this.contentBlock).first(),
                blockHeight = currentBlock[0] ? currentBlock[0].scrollHeight : 0,
                self = this;

            container.find(this.opener).find("button").attr('aria-expanded', 'true');
            container.find(this.contentBlock).attr('aria-hidden', 'false');

            currentBlock.velocity({
                height: blockHeight
            },{
                duration: this.duration,
                begin: function() {
                    container.addClass(self.classOpened);
                },
                complete: function(element) {
                    $(element).css({
                        height: 'auto'
                    });
                    self.container.trigger('openBlock', self.container, $(element));
                }
            });
        },

        _closeBlock: function(container) {
            var contentBlock = container.find(this.contentBlock).first(),
                self = this;

            container.find(this.opener).find("button").attr('aria-expanded', 'false');
            container.find(this.contentBlock).attr('aria-hidden', 'true');

            contentBlock.velocity({
                height: 0
            },{
                duration: this.duration,
                begin: function() {
                    container.removeClass(self.classOpened);
                },
                complete: function(element) {
                    self.container.trigger('closeBlock', self.container, $(element));
                }
            });
        },

        open: function(index) {
            if (arguments[0] !== undefined) {
                this._openBlock(this.blocks.eq(index));
            }
        },

        close: function(index) {
            if (arguments[0] !== undefined) {
                this._closeBlock(this.blocks.eq(index));
            }
        },

        openAllBlocks: function() {
            var self = this;
            this.blocks.each(function(index, element) {
                self._openBlock($(element));
            });
        },

        closeAllBlocks: function() {
            var self = this;
            this.blocks.each(function(index, element) {
                self._closeBlock($(element));
            });
        },

        _openBlocksImmediately: function() {
            var self = this;
            this.blocks.each(function(index, element) {
                $(element)
                    .find(self.contentBlock)
                    .first()
                    .height('auto');
            });
        },

        destroy: function() {
            this._openBlocksImmediately();
            this._unbindEvents();
        },

        _applySettings: function(defaultSettings, settings) {
            var self = this;

            settings = $.extend(defaultSettings, settings);

            $.each(settings, function(setting) {
                self[setting] = settings[setting];
            });
        },

        constructor: DPAccordion
    };

    $.fn.dpAccordion = function(options) {
        return this.each(function() {
            var currentElement = $(this);
            currentElement.data('dpAccordion', new DPAccordion(currentElement, options));
        });
    };

    return DPAccordion;

});
